import { render, staticRenderFns } from "./productGoods.vue?vue&type=template&id=0641a8b0&scoped=true"
import script from "./productGoods.vue?vue&type=script&lang=js"
export * from "./productGoods.vue?vue&type=script&lang=js"
import style0 from "./productGoods.vue?vue&type=style&index=0&id=0641a8b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641a8b0",
  null
  
)

export default component.exports